<crm-command-bar>

  <button mat-button class="crm-command-bar-button" [disabled]="true">
    <mat-icon>add</mat-icon>
    NEW
  </button>

  <button mat-button class="crm-command-bar-button" (click)="onRefresh()">
    <mat-icon>refresh</mat-icon>
    REFRESH
  </button>

</crm-command-bar>

<div class="crm-component-title-container">
  <h1 class="crm-component-title"> {{ 'ACTIVITIES_HEADER' | translate }} </h1>
</div>

<flow-task-list> </flow-task-list>

<!--

  <button mat-button class="crm-command-bar-button" [disabled]="true">

-->
